"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = exports.StyledCard = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const typography_1 = __importDefault(require("../typography"));
const card_1 = __importDefault(require("../card"));
const PREFIX = "BrandIntroCard";
exports.classes = {
    brandLogoButton: `${PREFIX}-brandLogoButton`,
    brandLogo: `${PREFIX}-brandLogo`
};
exports.StyledCard = (0, styles_1.styled)(card_1.default)(({ theme }) => ({
    width: "100%",
    height: "100%",
    background: "transparent",
    boxShadow: "none",
    padding: "24px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    [`& .${exports.classes.brandLogoButton}`]: {
        background: "transparent",
        "&:hover": {
            background: "transparent"
        }
    },
    [`& .${exports.classes.brandLogo}`]: {
        fill: theme.colours.white,
        height: "60px"
    }
}));
exports.Subtitle = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    margin: "12px 0",
    alignItems: "center",
    textAlign: "center",
    fontSize: "16px",
    lineHeight: 1.4,
    [theme.breakpoints.up(1024)]: {
        fontSize: "18px",
        margin: "24px 0"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2JyYW5kLWludHJvLWNhcmQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGlEQUE4QztBQUM5QywrREFBdUM7QUFDdkMsbURBQTJCO0FBRTNCLE1BQU0sTUFBTSxHQUFHLGdCQUFnQixDQUFDO0FBRW5CLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLGVBQWUsRUFBRSxHQUFHLE1BQU0sa0JBQWtCO0lBQzVDLFNBQVMsRUFBRSxHQUFHLE1BQU0sWUFBWTtDQUNqQyxDQUFDO0FBRVcsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsY0FBSSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3JELEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxVQUFVLEVBQUUsYUFBYTtJQUN6QixTQUFTLEVBQUUsTUFBTTtJQUNqQixPQUFPLEVBQUUsTUFBTTtJQUNmLE9BQU8sRUFBRSxNQUFNO0lBQ2YsVUFBVSxFQUFFLFFBQVE7SUFDcEIsYUFBYSxFQUFFLFFBQVE7SUFDdkIsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxlQUFlLEVBQUUsQ0FBQyxFQUFFO1FBQ2pDLFVBQVUsRUFBRSxhQUFhO1FBQ3pCLFNBQVMsRUFBRTtZQUNULFVBQVUsRUFBRSxhQUFhO1NBQzFCO0tBQ0Y7SUFDRCxDQUFDLE1BQU0sZUFBTyxDQUFDLFNBQVMsRUFBRSxDQUFDLEVBQUU7UUFDM0IsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUN6QixNQUFNLEVBQUUsTUFBTTtLQUNmO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFFBQVEsR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3pELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRSxRQUFRO0lBQ3BCLFNBQVMsRUFBRSxRQUFRO0lBQ25CLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLFVBQVUsRUFBRSxHQUFHO0lBQ2YsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQzVCLFFBQVEsRUFBRSxNQUFNO1FBQ2hCLE1BQU0sRUFBRSxRQUFRO0tBQ2pCO0NBQ0YsQ0FBQyxDQUFDLENBQUMifQ==